import { render, staticRenderFns } from "./BasicFooter.vue?vue&type=template&id=573b28ee&scoped=true&"
import script from "./BasicFooter.vue?vue&type=script&lang=js&"
export * from "./BasicFooter.vue?vue&type=script&lang=js&"
import style0 from "./BasicFooter.vue?vue&type=style&index=0&id=573b28ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b28ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VRow})
